<template>
    <TourLayout
        :config="config"
        :disabled="oneOrMoreCategoriesSelected"
        @action-completed="complete"
    >
        <div class="w-full">
            <DButton
                theme="secondary"
                data-cy="tour-subscription-select-all-button"
                wide
                @click="toggleAllOptions"
            >
                <template v-if="allCategoriesSelected">
                    Deselect all ({{ config.layout.categories.length }})
                </template>
                <template v-else>
                    Select all ({{ config.layout.categories.length }})
                </template>
            </DButton>

            <div class="flex flex-col mt-6 divide-y divide-(--border-neutral-subtle)">
                <div
                    v-for="option in config.layout.categories"
                    :key="option.value"
                    class="flex items-center justify-between py-4"
                    @click="toggleOption(option)"
                >
                    <span class="text-neutral-base text-base">
                        {{ option.title }}
                    </span>
                    <DSwitch
                        class="pointer-events-none"
                        :model-value="option.active"
                    />
                </div>
            </div>
        </div>
    </TourLayout>
</template>

<script setup>
    import { every } from 'lodash'

    import { DSwitch, DButton } from '@digistorm/spark'
    import { useTourStore } from '@/stores/tour'
    import TourLayout from './TourLayout.vue'

    const emit = defineEmits(['action-completed'])

    const props = defineProps({
        config: Object,
    })

    const tourStore = useTourStore()

    const oneOrMoreCategoriesSelected = computed(() => {
        return !some(props.config.layout.categories, { active: true })
    })

    const allCategoriesSelected = computed(() => {
        return every(props.config.layout.categories, { active: true })
    })

    const toggleOption = (option, value) => {
        option.active = value ?? !option.active
    }

    const toggleAllOptions = () => {
        if (allCategoriesSelected.value) {
            each(props.config.layout.categories, (option) => {
                toggleOption(option, false)
            })
        } else {
            each(props.config.layout.categories, (option) => {
                toggleOption(option, true)
            })
        }
    }

    const complete = () => {
        tourStore.selectedCategories = props.config.layout.categories.filter((item) => item.active).map((item) => item.value)
        emit('action-completed')
    }
</script>
